import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TVENT_PATTERNS = [
  /^\/tour-guide(\/|$)/i,
  /^\/join-tour(\/|$)/i,
  /^\/tour-participant(\/|$)/i
];

function ensureTag(selector, create) {
  let el = document.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

function setMeta(name, content) {
  const meta = ensureTag(
    `meta[name="${name}"]`,
    () => {
      const m = document.createElement("meta");
      m.setAttribute("name", name);
      return m;
    }
  );
  meta.setAttribute("content", content);
}

function setLink(rel, href) {
  const link = ensureTag(
    `link[rel="${rel}"]`,
    () => {
      const l = document.createElement("link");
      l.setAttribute("rel", rel);
      return l;
    }
  );
  // cache-bust to force re-fetch in browsers that cache manifests
  const v = href.includes("?") ? "&" : "?";
  link.setAttribute("href", `${href}${v}v=2`);
}

export default function DynamicAppMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isTvent = TVENT_PATTERNS.some((re) => re.test(pathname));

    if (isTvent) {
      setLink("manifest", "/manifest-tvent.json");
      setMeta("application-name", "Travy");
      setMeta("apple-mobile-web-app-title", "Travy");
      setLink("apple-touch-icon", "/icons/tvent-192.png");
      document.title = "Travy";
    } else {
      setLink("manifest", "/manifest-tvent.json");
      setMeta("application-name", "Travy");
      setMeta("apple-mobile-web-app-title", "Travy");
      setLink("apple-touch-icon", "/icons/tvent-192.png");
      document.title = "Travy";
    }
  }, [pathname]);

  return null;
}
